import { React } from "react";

import {
  Wrapper,
  Image,
  Logo,
  ImageDescription,
  ParagraphText,
} from "./Home.style";

const Home = () => (
  <>
    <Logo />
    <Wrapper>
      <div>
        <Image></Image>
        <ImageDescription>
          <a className="glitch"
            href="https://github.com/miracFence"
            target="_blank"
            rel="noopener noreferrer"
          >
            Github
          </a>{" "}
          |
          <a className="glitch"
            href="https://www.linkedin.com/in/eluney-hernández-64a5b719a"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            Linkedin
          </a>
        </ImageDescription>
      </div>

      <ParagraphText>
        <p>
          Hi! I’m a self-motivated, hard-working artificial intelligence student
          with work experience in Machine Learning and Full-Stack development (web, mobile,
          desktop). My passion is centered in studying and applying Machine
          Learning, Cryptography and Research related to state-of-the-art
          Privacy Enhancing Technologies, such as Differential Privacy and
          Federated Learning. In the past, I’ve worked on multiple academic
          projects, demonstrating technical leadership, communication and
          excellent organizational skills. Besides of that, I’m passionate about
          ML research, particularly about topics related to Deep Learning and
          PPML, and one of my main objectives is to study and solve
          intelligence, while creating safe AI systems. In the last couple of
          days, I created a Kaggle account and I’ve been obsessed with it...
          <br />
          <br />
          <ul>
            ACADEMIC & SIDE PROJECTS:
            <li>"All I can eat" - Recipes generator website made with React and Firebase (On progress)</li>
            <li>S0rt1t -  Sorting visualization website made with React (On progress)</li>
            <li>"I am the canvas" website made with React and Tensorflowjs (On progress)</li>
            <li>Real time temperature measuring and mask detection - Made with Jetson Xavier NX (On progress)</li>
            <li>Sort4pp - An iOS sorting visualization app</li>
            <li>stor.io - AI Poetry Generator on the web</li>
            <li>Recipes generator with GPT-2 and GPT-Neo</li>
            <li>Nimble - A small programming language made in C++</li>
            <li>Artsy - Digital art e-commerce website made with Vuejs & Firebase</li>
            <li>System Administration software made with C# and MySQL</li>
          </ul>
          <br />
          <ul>
            CURRENT RESEARCH PROJECTS (On progress)
            <li>Federated Learning - Fairness</li>
            <li>Causal Discovery</li>
            <li>Capsule Neural Networks for molecules' 3D representations</li>
            <li>Using Privacy Enhancing Technologies on wireless networks</li>
          </ul>
          <br />
          <ul>
            ACADEMIC/SCIENTIFIC GROUPS:
            <li>Colibri Mission - Software Member @Universidad Panamericana Campus Bonaterra</li>
            <li>Legión - IoT/Edge AI developer @Universidad Panamericana Campus Bonaterra</li>
            <li>Data Science Group - DS Competitions Coordinator @GrupoPanteras</li>
            <li>iOS Development Lab - Software Developer @GrupoPanteras</li>
            <li>Front End Development Group - Software Developer  @GrupoPanteras</li>
            <li>LegalTech - Software Engineer @GrupoPanteras</li>
          </ul>
          <center>
            <br/>
          <footer>&copy; 2021 Eluney Hernández</footer>
          </center>
        </p>
      </ParagraphText>
    </Wrapper>
  </>
);

export default Home;
